module.exports = {
	"root": "findify-components--text",
	"primary-uppercase": "findify-components--text__primary-uppercase",
	"primaryUppercase": "findify-components--text__primary-uppercase",
	"primary-lowercase": "findify-components--text__primary-lowercase",
	"primaryLowercase": "findify-components--text__primary-lowercase",
	"secondary-uppercase": "findify-components--text__secondary-uppercase",
	"secondaryUppercase": "findify-components--text__secondary-uppercase",
	"secondary-lowercase": "findify-components--text__secondary-lowercase",
	"secondaryLowercase": "findify-components--text__secondary-lowercase",
	"title": "findify-components--text__title",
	"bold": "findify-components--text__bold",
	"inlineBlock": "findify-components--text__inlineBlock"
};